import Level01 from './level01';
import Level02 from './level02';

export default [
  {
    path: '/',
    scene: Level01,
  },
  {
    path: '/test',
    scene: Level02,
  },
];
